import { Button, Divider, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import CustomAddCountryInput from '../../../../Components/CustomInputLogin/CustomAddCountryInput';
import * as Yup from "yup";
import CustomUserRegisterDropdown from '../../../../Components/CustomDropDown/CustomUserRegisterDropdown';
import { useDispatch } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import { ViewKanban } from '@mui/icons-material';

const CityAdd = ({ setTabValue }) => {
    const [inputValue, setInputValue] = useState("");
    const [localValues, setLocalValues] = useState([]);




    const [countryNames, setCountryNames] = useState([]);
    const [stateNames, setStateNames] = useState([]);
    const [cityNames, setCityNames] = useState([]);

    const [selectedCountryId, setSelectedCountryId] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(null);

    // Fetch countries on component mount
    const dispatch = useDispatch()
    useEffect(() => {
        // if (!open) return; // Only fetch when modal is open

        const fetchCountries = async () => {
            const data = {
                data: {},
                method: "get",
                apiName: "getAllCountryNames",
            };

            const responseData = await dispatch(actions.GETALLCOUNTRYNAMES(data));

            if (responseData?.payload?.message === "Countries retrieved successfully.") {
                const formattedCountries =
                    responseData?.payload?.data?.map((country) => ({
                        label: country.country_name,
                        value: country.country_name,
                        id: country.country_id, // Store country ID
                    })) || [];

                setCountryNames(formattedCountries);
            }
        };

        fetchCountries();
    }, []);

    // Handle country selection
    const handleCountryChange = (selectedValue, selectedId) => {
        console.log("Selected Country:", selectedValue);
        console.log("Selected Country ID:", selectedId);

        // setSelectedCountryId(selectedId);
        setStateNames([]); // Reset states
        // setCityNames([]); // Reset cities

        if (selectedId) {
            fetchStates(selectedId);
            setSelectedCountryId(selectedId);

        }
    };

    // Fetch states based on selected country
    const fetchStates = async (countryId) => {
        const data = {
            data: { country_id: countryId },
            method: "get",
            apiName: `getAllStatesByCountry/${countryId}`,
        };

        const response = await dispatch(actions.GETALLSTATESBYCOUNTRY(data));

        if (response?.payload?.message === "States fetched successfully.") {
            const formattedStates =
                response?.payload?.data?.map((state) => ({
                    label: state.state_name,
                    value: state.state_name,
                    id: state.state_id, // Store state ID
                })) || [];

            setStateNames(formattedStates);
        }
    };

    // Handle state selection
    const handleStateChange = (selectedValue, selectedId) => {
        console.log("Selected State:", selectedValue);
        console.log("Selected State ID:", selectedId);

        // setSelectedStateId(selectedId);
        // setCityNames([]); // Reset cities

        if (selectedId) {
            setSelectedStateId(selectedId);
        }
    };


    const handleSubmit = async (values) => {
        // if (!open) return;

        // if (inputValue.trim() !== "") {
        //     values.country = [...values.country]; // Include the last typed value
        // }


        const data1 = {
            data: {
                state_id: selectedStateId,
                cities: values.city
            },
            method: "post",
            apiName: `addMultipleCities`
        };
        const responseData = await dispatch(actions.ADDSTATEPOST(data1))

        // handleSubmit(values)
        console.log(values, "valuessssss")
        if (responseData?.payload?.message === "Cities added successfully.") {
            // console.log(values, "valuessssss");
            setInputValue("");
            setLocalValues([]);
            setTabValue(3)
        } else {
            toast.error(responseData?.payload?.message)
        }
    };


    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={{
                    country: "",
                    state: "",
                    city: []

                }}
                validationSchema={Yup.object({
                    // country: Yup.array().min(1, "At least one country is required"),
                    country: Yup.string().required("Country is required"),
                    state: Yup.string().required("state is required"),


                    city: Yup.array().min(1, "At least one country is required"),
                })}
                onSubmit={(values, { setFieldValue }) => {
                    if (inputValue.trim() !== "") {
                        setFieldValue("city", [...values.city, inputValue]); // Add inputValue to state array
                    }

                    handleSubmit(values)
                    
                }}
            >
                {({ handleSubmit, setFieldValue, resetForm, values }) => (
                    <Form onSubmit={handleSubmit}>
                        {/* <DialogContent dividers> */}
                        <Grid container spacing={2} mb={4}>
                            <Grid item xs={12} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <CustomUserRegisterDropdown
                                            name="country"
                                            label="Country"
                                            custPlaceholder="Select Country"
                                            options={countryNames}
                                            // options={[
                                            //     { label: "Individual", value: "Individual" },
                                            //     { label: "Institutional", value: "Institutional" },
                                            // ]}
                                            onChange={handleCountryChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <CustomUserRegisterDropdown
                                            name="state"
                                            label="State"
                                            custPlaceholder="Select State"
                                            options={stateNames}
                                            // options={[
                                            //     { label: "Individual", value: "Individual" },
                                            //     { label: "Institutional", value: "Institutional" },
                                            // ]}
                                            onChange={handleStateChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <CustomAddCountryInput
                                            label="City"
                                            name="city"
                                            inputType="text"
                                            custPlaceholder="Enter City"
                                            setFieldValue={setFieldValue}
                                            values={values.country}
                                            inputValue={inputValue} // Pass inputValue
                                            setInputValue={setInputValue} //
                                            localValues={localValues}
                                            setLocalValues={setLocalValues}

                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider />


                        <Grid sx={{ display: "flex", justifyContent: "end", mt: 1 }}>
                            <Grid>
                                <Button
                                    onClick={() => {
                                        resetForm();
                                        // setUploadedFiles(null);
                                        // onClose()
                                        // dispatch(clearCustomerId(null))
                                        // dispatch(clearTableGetId(null))


                                    }}
                                    variant="text"
                                    // className="custom-clear-button"
                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        mr: "10px",
                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "white",
                                        boxShadow: "none",
                                        color: "black",
                                        border: "1px solid black",
                                        "&:hover": {
                                            backgroundColor: "#3B4056",
                                            color: "white",
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    // className="custom-ok-button"
                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        boxShadow: "none",

                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "#C38F51 0% 0% no-repeat padding-box",
                                        "&:hover": {
                                            backgroundColor: "#3B4056",
                                            boxShadow: "none",
                                        },
                                    }}
                                >
                                    {/* {customerId ? "Update" : "Submit"} */}

                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                        {/* </DialogContent> */}

                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default CityAdd